import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./module");

export default function keepReadingLoader(context) {
    loadModuleOnElement(".js-keep-reading", loader, context, true);
    return context;
}
